import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    children: React.ReactNode;
    className?: string;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children, className = 'max-w-md' }) => {

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => { document.body.style.overflow = 'unset'; };
    }, [isOpen]);

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className="fixed inset-0 z-50 overflow-y-auto">
            {/* Backdrop oscuro con blur */}
            <div
                className="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity"
                onClick={onClose}
            ></div>

            {/* Contenedor del Modal Centrado */}
            <div className="flex min-h-full items-center justify-center p-4">
                <div
                    className={`relative w-full ${className} transform rounded-2xl bg-white p-6 text-left shadow-2xl transition-all animate-fade-in-up`}
                >
                    {/* Header */}
                    <div className="flex items-center justify-between mb-5 border-b border-[var(--st-border)] pb-4">
                        <h3 className="font-display text-xl font-bold text-[var(--st-text-primary)]">
                            {title}
                        </h3>
                        <button
                            onClick={onClose}
                            className="text-[var(--st-text-muted)] hover:text-[var(--st-text-primary)] transition-colors p-1 rounded-full hover:bg-[var(--st-bg-tertiary)]"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
                        </button>
                    </div>

                    {/* Body */}
                    <div>
                        {children}
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default Modal;